import { NgModule } from "@angular/core";
import { TranslatePipe } from "../core/pipes/translate.pipe";
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { CommonModule, DatePipe } from "@angular/common";
import { MAT_DATE_LOCALE, MatNativeDateModule, MatPseudoCheckboxModule } from "@angular/material/core";
import { MAT_FORM_FIELD_DEFAULT_OPTIONS, MatFormFieldDefaultOptions, MatFormFieldModule } from "@angular/material/form-field";
import { LightBoxImgComponent } from "./light-box-img/light-box-img.component";
import { MatInputModule } from "@angular/material/input";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatDialogModule } from "@angular/material/dialog";
import { MatIconModule } from "@angular/material/icon";
import { MatDatepickerModule } from '@angular/material/datepicker';
import { RouterModule } from "@angular/router";
import { MatSelectModule } from '@angular/material/select';
import { UploadBoxSharedComponent } from "./upload-box-shared/upload-box-shared.component";
import { NumberValueSharedComponent } from "./number-value-shared/number-value-shared.component";
import { MatTooltipModule } from '@angular/material/tooltip';
import { ImgLoaderComponent } from "./img-loader/img-loader.component";
import { MatCheckboxModule } from '@angular/material/checkbox';
import { LikeCountPipe } from "../core/pipes/currShortcut.pipe";
import { HeaderComponent } from "./header/header.component";
import { FooterComponent } from "./footer/footer.component";
import { BtnLoaderComponent } from "./btn-loader/btn-loader.component";



const shared = [
    MatSnackBarModule,
    MatFormFieldModule,
    MatInputModule,
    FormsModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatNativeDateModule,
    MatIconModule,
    MatPseudoCheckboxModule,
    RouterModule,
    MatDatepickerModule,
    MatSelectModule,
    MatTooltipModule,
    MatCheckboxModule,
]

@NgModule({
    declarations: [
        TranslatePipe,
        LightBoxImgComponent,
        UploadBoxSharedComponent,
        NumberValueSharedComponent,
        LikeCountPipe,
        ImgLoaderComponent,
        HeaderComponent,
        FooterComponent,
        BtnLoaderComponent
    ],
    imports: [
        CommonModule,
        [...shared]
    ],
    exports: [
        [...shared],
        TranslatePipe,
        LightBoxImgComponent,
        UploadBoxSharedComponent,
        NumberValueSharedComponent,
        LikeCountPipe,
        ImgLoaderComponent,
        HeaderComponent,
        FooterComponent,
        BtnLoaderComponent
    ],
    providers: [
        DatePipe,
        {
            provide: MAT_DATE_LOCALE, useValue: 'en-GB'
        },
        {
            provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
            useValue: {
                appearance: 'fill'
            } as MatFormFieldDefaultOptions
        }
    ],
})
export class SharedModule { }
